import React, { useEffect, useRef, useState } from 'react'

/**
 * Fades/slides content in when it enters the viewport (Intersection Observer).
 * Respects prefers-reduced-motion.
 */
const ScrollReveal = ({
  children,
  className = '',
  as: Component = 'div',
  threshold = 0.12,
  rootMargin = '0px 0px -8% 0px',
  once = true,
}) => {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    if (reduceMotion.matches) {
      setVisible(true)
      return undefined
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          setVisible(true)
          if (once) observer.unobserve(entry.target)
        })
      },
      { threshold, rootMargin }
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [threshold, rootMargin, once])

  return (
    <Component
      ref={ref}
      className={`scroll-reveal ${visible ? 'scroll-reveal--visible' : ''} ${className}`.trim()}
    >
      {children}
    </Component>
  )
}

export default ScrollReveal
